$('.js-product-select').on('change', function () {
  let optionData = '';

  $('.js-product-select').each(function () {
    let $this = $(this);
    let optionName = $this.data('name');
    let optionValue = $this.find('option:selected').val();

    optionData += `[data-${optionName}="${optionValue}"]`;
  });

  let value = $(`.js-product-hidden-select option${optionData}`).val();

  $('.js-product-hidden-select').val(value).change();
});

$('.js-product-hidden-select').on('change', function () {
  const $this = $(this);
  const $price = $this.closest('.js-product-single').find('.js-price-wrapper');

  if ($this.find(':selected').prop('disabled')) {
    $('.js-product-add-to-cart').prop('disabled', true);
    $('.js-sticky-add-to-cart').addClass('disabled');
  } else {
    $('.js-product-add-to-cart').prop('disabled', false);
    $('.js-sticky-add-to-cart').removeClass('disabled');
  }

  $price.add('.js-product-bar').find('.js-compared-price').text($this.find('option:selected').data('compared_price'));
  $price.add('.js-product-bar').find('.js-price').text($this.find('option:selected').data('price'));
});
